<template>
    <div class="authority-add">
        <content-header :title="userId ? $t('authority.member') :  $t('authority.add_member')"></content-header>
        <div class="authority-add-bg">
            <div class="authority-add-section">
                <!--<h1>分组A - 组员信息</h1>-->
                <div class="authority-add-state">
                    <div>
                        <p>{{$t('authority.name')}}</p>
                        <el-input v-model="userName" :placeholder="$t('message.enter')"></el-input>
                    </div>
                    <div>
                        <p>{{$t('authority.phone')}}</p>
                        <el-input v-model="phone" :placeholder="$t('message.enter')"></el-input>
                    </div>
                    <div>
                        <p>{{$t('authority.state')}}</p>
                        <el-switch
                                v-model="is_enable"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                :active-value="0"
                                :inactive-value="1">
                        </el-switch>
                    </div>
                </div>
                <div class="authority-add-state">
                    <h5>{{$t('authority.add.account_password')}}</h5>
                    <span></span>
                    <div>
                        <p>{{$t('authority.email')}}</p>
                        <el-input v-model="email" :placeholder="$t('message.enter')"></el-input>
                    </div>
                    <div v-if="!userId">
                        <p>{{$t('authority.password')}}</p>
                        <el-input v-model="password" :placeholder="$t('message.enter')"></el-input>
                    </div>
                </div>
                <div class="authority-add-state">
                    <h5>{{$t('authority.authority')}}</h5>
                    <span></span>
                    <template>
                        <el-checkbox-group v-model="checkList" >
                            <el-checkbox v-for="item in authList" :key="item.id"  :value="item.id" :label="item.id">{{item.i18n_name}}</el-checkbox>
                        </el-checkbox-group>
                    </template>
                </div>
            </div>
            <div>
                <el-button v-if="!userId" type="success" @click="addMember">完成新增</el-button>
                <el-button v-else type="success" @click="editMember">保存</el-button>
                <el-button @click="closeAdd">关闭</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import contentHeader from '../../components/content-header'
    
    import Core from "core/core";
    import i18n from "../../../src/locales";
    export default {
        data(){
            return {
                userId: '',
                userName: '',
	            groupId: '',
                phone: '',
                email: '',
                password: '',
                is_enable: '',
                checkList: [],
	            detailList: '',
                authList: '',
                checkIdList: [],
                checkShow: true
            }
        },
        components:{
            contentHeader
        },
        mounted(){
	        this.userId = this.$route.query.userId;
	        this.groupId = this.$route.query.groupId;
	        console.log (this.groupId)
	        this.getAuthList()
            this.initDetailList()
        },
        methods:{
            initDetailList(){
                if (this.userId)  {
	                Core.Api.User.detail(this.userId).then((res)=>{
		                this.detailList = res
		                this.userName = res.username
		                this.phone = res.phone
		                this.is_enable = res.is_enable
		                this.email = res.email
		                res.authority.map((item) => {
		                    this.checkList.push(item.id)
		                })
	                })
                }

            },
            getAuthList(){
                Core.Api.Auth.authList().then((res)=>{
                    console.log('authList', res);
                    let list = res.auth_list
                    list.forEach((item) => {
                        item['i18n_name'] = i18n.t('auth.' + item.key)
                    })
                    list.splice(2,1)
                    this.authList = list
                    // console.log(this.authList,'权限列表');
                })
            },

            check(){
                if(this.email){
                    let email = this.email
	                let emailReg = Core.Const.EMAIL_REG
	                if( emailReg.test(email) ){
                        if(this.password.length>0 || this.userId){
                            this.checkShow = false
                        } else {
                            this.$message.error('请输入密码');
                        }
                    } else {
                        this.checkShow = true
                        this.$message.error('邮箱格式不正确');
                    }
                } else {
                    this.checkShow = true
                    this.$message.error('请输入邮箱');
                }
            },
            addMember(){
                if(this.userName && this.phone && this.email && (this.password || this.userId)) {
	                // if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone))){
		            //     this.$message.error('手机号码有误，请重填');
		            //     return false;
	                // }
                    this.check()
                    if (!this.checkShow){
                        Core.Api.User.createMember(
                            this.groupId,
                            this.userName,
                            this.phone,
                            this.email,
                            this.password,
                            this.is_enable,
                            this.checkList
                        ).then(res => {
                            console.log(res);
                            this.$message.success('添加成功');
                            this.$router.push('/authority')
                        }).catch(err => {
                            console.error(err);
                        });
                    }
                } else {
                    this.$message.error('请将信息补充完整');
                }
            },
	        editMember() {

		        if(this.userName && this.phone && this.email && (this.password || this.userId)) {
			        // if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone))){
				    //     this.$message.error('手机号码有误，请重填');
				    //     return false;
			        // }
			        this.check()
			        if (!this.checkShow){
				        Core.Api.User.updateAfmMember(
					        this.userId,
					        this.userName,
					        this.phone,
					        this.is_enable,
					        this.email,
					        this.checkList
				        ).then(res => {
					        console.log(res);
					        this.$message.success('保存成功');
					        this.$router.push('/authority')
				        }).catch(err => {
					        console.error(err);
				        });
			        }
		        } else {
			        this.$message.error('请将信息补充完整');
		        }
	        },
            closeAdd(){
                this.$router.push('/authority')
            }
        }
    }
</script>

<style scoped lang="scss">
    .authority-add {
        height: 800px;
        .authority-add-bg {
            margin-top: 30px;
            position: absolute;
            left: 18vw;
            right: 18vw;
            .authority-add-section {

                h1 {
                    font-size: 20px;
                }
                h5 {
                    font-size: 14px;
                    margin-top: 30px;
                }
                .authority-add-state {
                    >span {
                        display: inline-block;
                        width: 100%;
                        height: 1px;
                        background: #EBEDF3;
                    }
                    >div {
                        >p {
                            margin-bottom: 6px;
                            font-size: 14px;
                            color: #7A8799;
                        }
                        display: inline-block;
                        width: 45%;
                        margin-right: 4.5%;
                        margin-top: 20px;
                    }
                }
            }
        }

    }

</style>
<style lang="scss">
    .authority-add-state {
        input {
            height: 40px;
        }
        .is-checked{
            .el-checkbox__inner{
                background: #0AC47A;
                border: #0AC47A;
            }
            .el-checkbox__label{
                color: #31C27C;
            }
        }
    }
    .authority-add-bg {
        .el-button {
            height: 40px;
            font-size: 15px;
            margin-top: 60px;
            width: 116px;
        }
    }
</style>